import React from 'react';
import { Box } from '@mui/material';

const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL;

const LoadingShells = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'fixed', // Ensures the Box stays fixed relative to the viewport
                top: 0,
                left: 0,
                width: '100vw', // Full width of the viewport
                height: '100vh', // Full height of the viewport
                backgroundColor: 'rgba(255, 255, 255, 0.6)', // Optional: Add a semi-transparent background
                zIndex: 9999, // Ensure it's above other content
            }}
        >
            <img
                src={`${IMAGE_URL}char_gifs/misc/shells.gif`}
                alt="Loading..."
                style={{ width: '50%', maxWidth: '300px' }} // Adjust size as needed
            />
        </Box>
    );
};

export default LoadingShells;
